import { MessageCircle, MoreVertical, Star, MapPin } from "lucide-react"
import { Button } from "@/components/ui/Button"
import { Avatar } from "@/components/ui/Avatar"
import { Badge } from "@/components/ui/badge"
import type { Contact } from "../lib/data"

interface ContactListItemProps {
  contact: Contact
  onAction: (action: string) => void
}

export const ContactListItem = ({ contact, onAction }: ContactListItemProps) => {
  return (
    <div className="group flex items-center gap-4 bg-card border border-border hover:bg-muted/50 rounded-xl px-4 py-3 transition-colors">
      <Avatar
        src={contact.avatar}
        fallback={contact.name.charAt(0)}
        className="size-10 shrink-0"
      />

      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-1">
          <h3 className="text-foreground font-medium truncate">{contact.name}</h3>
          {contact.isStarred && (
            <Star className="size-3 fill-yellow-400 text-yellow-400 shrink-0" />
          )}
        </div>
        <p className="text-muted-foreground text-sm truncate">{contact.role} · {contact.company}</p>
      </div>

      <div className="hidden lg:flex gap-1 shrink-0">
        {contact.tags.slice(0, 2).map((tag) => (
          <Badge key={tag} variant="secondary" size="sm" className="text-xs">
            {tag}
          </Badge>
        ))}
      </div>

      <div className="hidden xl:flex items-center gap-1 shrink-0 w-32">
        <MapPin className="size-3 text-muted-foreground/50" />
        <span className="text-muted-foreground text-xs truncate">{contact.location}</span>
      </div>

      <span className="text-muted-foreground/50 text-xs w-24 text-right shrink-0 hidden md:block">
        {contact.lastContact}
      </span>

      <div className="flex gap-2 shrink-0">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onAction(`Message ${contact.name}`)}
        >
          <MessageCircle className="size-4" />
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onAction(`View ${contact.name} Profile`)}
        >
          <MoreVertical className="size-4" />
        </Button>
      </div>
    </div>
  )
}
